export default __webpack_public_path__ + "static/media/blurry_gradient_red.9cc0772d.png";